export const correctBadUriHtmlEncoding = (s: string): string => {
  if (!s || !s.includes('%')) {
    return s;
  }
  return s
    .replace(/%26/g, '&')
    .replace(/%27/g, "'")
    .replace(/%2A/g, '*')
    .replace(/%2B/g, '+')
    .replace(/%2D/g, '-')
    .replace(/%2E/g, '.')
    .replace(/%2F/g, '/')
    .replace(/%3D/g, '=')
    .replace(/%3F/g, '?')
    .replace(/%5E/g, '^')
    .replace(/%5F/g, '_')
    .replace(/%7B/g, '{')
    .replace(/%7D/g, '}')
    .replace(/%7E/g, '~');
};
